module.exports = __webpack_public_path__ + "img/Eventinquiry_headerimage.efc68c01.jpg";